import React from 'react';
import PropTypes from 'prop-types';

function IconPlayRight({ color = '#121212', size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.05244 2.11831L12.252 7.77318C12.4321 7.89737 12.4321 8.16349 12.252 8.28768L4.05244 13.9425C3.84513 14.0856 3.56244 13.9371 3.56244 13.6852V2.37556C3.56244 2.12368 3.84513 1.97531 4.05244 2.11831Z" fill={color}/>
    </svg>
  )
}

IconPlayRight.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconPlayRight;
